import { useSuspenseQuery } from '@apollo/client';
import { useStandortContext } from '@/features/standortContext/StandortContext';
import {
  SummeNetto,
  Vertrag,
  VertragZahlungsmethode,
} from '@/domain/vertraege/shared/types/vertrag';
import { GET_VERTRAEGE_BY_STANDORTID } from '@/domain/vertraege/shared/hooks/graphql/queries';

export function useVertraege(): {
  vertraege?: Vertrag[];
  error?: string;
} {
  const { standorte } = useStandortContext();
  const standortIds = standorte.map((standort) => standort.id);
  const { data } = useSuspenseQuery(GET_VERTRAEGE_BY_STANDORTID, {
    variables: {
      idStandorte: standortIds,
    },
    fetchPolicy: 'network-only',
  });

  if (data.vertraegeByIdStandort.length < 1) {
    return {
      vertraege: [],
    };
  }

  const result = data.vertraegeByIdStandort.filter(
    (vertragsdaten) => vertragsdaten !== null && vertragsdaten.id.length > 0,
  );

  return {
    vertraege: result.map(
      (vertrag) =>
        new Vertrag({
          id: vertrag.id,
          kundennummer: vertrag.kundennummer,
          unternehmensname: vertrag.unternehmensname,
          aktiveAnzahl: vertrag.aktiveAnzahl,
          vereinbarteAnzahl: vertrag.vereinbarteAnzahl,
          vertragTarif: vertrag.vertragTarif,
          vertragIntervall: vertrag.vertragIntervall,
          faelligkeitsdatum: vertrag.faelligkeitsdatum,
          summeNetto: new SummeNetto({
            waehrung: vertrag.summeNetto.waehrung,
            wert: vertrag.summeNetto.wert,
          }),
          vertragZahlungsmethode:
            VertragZahlungsmethode[vertrag.vertragZahlungsmethode],
          preisModell: vertrag.preisModell,
        }),
    ),
  };
}
